import ApiService from '@/common/api.service'

export default {
  getQuestionByQuestionNumber (numberQuestion) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/diagnosis/question?numberQuestion=${numberQuestion}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getDiagnosisAnswer (questionCheckedIds) {
    return new Promise((resolve, reject) => {
      ApiService.post('/diagnosis/diagnosisAnswer', questionCheckedIds).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  createOrUpdateDisputeAns (disputeAns) {
    return new Promise((resolve, reject) => {
      ApiService.post('/diagnosis/createOrUpdateAnswer', disputeAns).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  loadDisputeQuestion (numberQuestion) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/diagnosis/disputeQuestionAndAnswer`, {
          params: {
              numberQuestion
          }
      }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
